import { InputBaseComponentProps, TextFieldProps } from '@mui/material';
import React from 'react';
import { IMaskInput } from 'react-imask';
import { PHONE_MASKS, getTaxPayerMask } from 'services/mask';

type CustomProps = InputBaseComponentProps &
  Pick<TextFieldProps, 'name'> & {
    onChange?: (event: { target: { name: string; value: string } }) => void;
    mask: string;
  };

const TextFieldMask = React.forwardRef<CustomProps, CustomProps>(function TextFieldMask(
  props,
  ref,
) {
  const { onChange, ...other } = props;

  return (
    <IMaskInput
      {...other}
      inputRef={ref}
      onAccept={(value: never) =>
        onChange && props.name && onChange({ target: { name: props?.name, value } })
      }
      overwrite
    />
  );
});

function PhoneTextFieldMask(props: InputBaseComponentProps) {
  return (
    <TextFieldMask
      mask={[
        { mask: PHONE_MASKS.PHONE9 },
        { mask: PHONE_MASKS.PHONE },
        { mask: PHONE_MASKS.PHONE_DDD },
        { mask: PHONE_MASKS.PHONE_0800, startsWith: '0800' },
        { mask: PHONE_MASKS.PHONE9_DDD },
        { mask: PHONE_MASKS.PHONE_INT },
        { mask: PHONE_MASKS.PHONE9_INT },
      ]}
      {...props}
    />
  );
}

function TaxPayerTextFieldMask(props: InputBaseComponentProps) {
  return <TextFieldMask mask={getTaxPayerMask(props?.value)} {...props} />;
}

export default Object.assign({}, TextFieldMask, {
  Phone: PhoneTextFieldMask,
  TaxPayer: TaxPayerTextFieldMask,
});
